module.exports = __webpack_public_path__ + "img/31.2b636270.png";